module.exports = __webpack_public_path__ + "img/settings.bcce7bd0.svg";